import { render, staticRenderFns } from "./AssistenteRecomendacaoConsulta.vue?vue&type=template&id=7a6f7eb0&scoped=true&"
import script from "./AssistenteRecomendacaoConsulta.vue?vue&type=script&lang=js&"
export * from "./AssistenteRecomendacaoConsulta.vue?vue&type=script&lang=js&"
import style0 from "./AssistenteRecomendacaoConsulta.vue?vue&type=style&index=0&id=7a6f7eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f7eb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VIcon,VList,VListItem,VMenu,VProgressCircular,VRow,VSimpleTable})
